module.exports = __webpack_public_path__ + "h5/img/head2.8fffcea5.png";